import React from "react";
import { Card, Row, Col } from "react-bootstrap";

const SummaryCard = ({ campaignData = {}, credits = 0 }) => {
  const count = campaignData.contactListCount || 0;
  const baseLength = campaignData.messageTemplate?.length || 0;
  const totalLength = baseLength > 0 ? baseLength + 27 : 0;
  const segmentSize = campaignData.messageType === "mms" ? 1600 : 160;
  const segments = Math.ceil(totalLength / segmentSize) || 0;
  
  let costPerContact = 0;
  if (campaignData.messageType === "mms") {
    costPerContact = segments * 8;
  } else {
    costPerContact = segments * 3;
  }
  
  const totalCreditsCost = count * costPerContact;

  return (
    <Card style={{ borderRadius: "10px", padding: "25px 25px 50px 20px", boxShadow: "0px 1px 6px rgba(0,0,0,0.1)" }}>
    <Card.Body>
      <h3 style={{ fontWeight: "700", margin:'0' }}>Campaign Summary</h3>
      <div className="mt-3">
        <p style={{fontWeight:'700'}} className="mb-1 text-muted">Target Contacts</p>
        <h5 style={{ fontWeight: "600",marginBottom:"20px" }}>{count.toLocaleString()}</h5>
  
        <p style={{fontWeight:'700'}} className="mb-1 text-muted mt-3">Estimated Cost</p>
        <h5 style={{ fontWeight: "600",marginBottom:"20px" }}>{totalCreditsCost.toLocaleString()} Credits</h5>

        <p style={{fontWeight:'700'}} className="mb-1 text-muted mt-3">Available Credits</p>
        <h5 style={{ fontWeight: "600",marginBottom:"20px", color: "#28a745" }}>{credits.toLocaleString()} Credits</h5>
      </div>
    </Card.Body>
  </Card>
  
  );
};

export default SummaryCard;
